const BodyTypes = [
  { label: 'Convertible', value: 'convertible' },
  { label: 'Coupe', value: 'coupe' },
  { label: 'Estate', value: 'estate' },
  { label: 'Hatchback', value: 'hatchback' },
  { label: 'Mpv', value: 'mpv' },
  { label: 'Pick up', value: 'pick up' },
  { label: 'Saloon', value: 'saloon' },
  { label: 'Suv', value: 'suv' },
]

export default BodyTypes
